import { render, staticRenderFns } from "./complaint-commit.vue?vue&type=template&id=fa09d1e0&scoped=true&"
import script from "./complaint-commit.vue?vue&type=script&lang=js&"
export * from "./complaint-commit.vue?vue&type=script&lang=js&"
import style0 from "./complaint-commit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./complaint-commit.vue?vue&type=style&index=1&id=fa09d1e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa09d1e0",
  null
  
)

export default component.exports